import { STARTING_MODULE_STORE_KEY } from '../constants';

export default (state: GlobalState) => state[STARTING_MODULE_STORE_KEY].modules;
